import { sha256 } from 'js-sha256';

export function hashStringWithSHA256(input: string): string {
  return sha256(input);
}
